import Vue from 'vue';
import Loading from '@/components/Loading';

let timeout;
let queue = [];
const LoaderComponent = Vue.extend(Loading);
Vue.prototype.$loader = new LoaderComponent();

let execing = false;
let endFunc = null;
async function exec(end) {
  endFunc = end;
  if (!execing) {
    execing = true;

    let f = queue.shift();
    while (f) {
      // eslint-disable-next-line no-await-in-loop
      await f.catch(() => { });
      f = queue.shift();
    }

    queue = [];
    execing = false;

    if (!execing) endFunc();
  }
}

Vue.prototype.$loading = async function loading(action, interval = 100) {
  const vm = this;

  let result;
  try {
    result = action();
    if (result.then === undefined) {
      result = Promise.resolve();
    }
  } catch (err) {
    result = Promise.reject(err);
  }

  queue.push(result);

  if (!vm.$root.$el) {
    throw new Error('root element not initialized');
  }

  clearTimeout(timeout);

  // eslint-disable-next-line no-underscore-dangle
  if (!vm.$loader._isMounted) {
    vm.$loader.$mount();
  }

  if (!vm.$root.$el.contains(vm.$loader.$el)) {
    vm.$root.$el.appendChild(vm.$loader.$el);
  }

  exec(() => {
    timeout = setTimeout(() => {
      if (vm.$loader.$el) vm.$loader.$el.remove();
    }, interval);
  });

  await result;
};
